'use strict';

/* globals window, $ */

var React = require('react');
var _ = require('lodash');

var at = require('../../utils/environment');


var NETWORKS = ['facebook', 'twitter', 'google', 'whatsapp'];
var shareBar;


if (at.client) {
    var initShareBar = function() {
        var facebookId = window.SETTINGS && window.SETTINGS.FACEBOOK_APP_ID;
        var shareBarOptions = {
            selector: '#__devnull__',
            networks: NETWORKS,
            onShare: function() {
                    // workaround para forçar a execução do Fb.ui sempre com popup.
                    if (!window.FBUI && window.FB) {
                        window.FBUI = window.FB.ui;
                        window.FB.ui = function() {
                            var options = arguments[0];
                            options.display = 'popup';
                            arguments[0] = options;
                            window.FBUI.apply(window.FB, arguments);
                        };
                    }
            }
        };

        if (facebookId) {
            shareBarOptions.facebookAppId = facebookId;
        }

        try {
            shareBar = new window.ShareBar(shareBarOptions);
        } catch(e) {
            console.warn('Soft error: ShareBar have failed to initialize');
            console.error(e);
        }
    };

    if (window.ShareBar) initShareBar();
    else if (window.$) $(document).ready(initShareBar);
}


var Share = React.createClass({
    componentDidMount: function() {
        if (shareBar) {
            this.createBar();
        }
        else if (window.$) {
            $(document).ready(_.bind(this.createBar, this));
        }
    },

    createBar: function() {
        var node;

        try {
            node = this.refs.innerDiv;
            shareBar.createBar(node);
        } catch(e) {
            console.warn('Soft error: could not create a new ShareBar');
            console.error(e);
        }
    },

    render: function() {
        if (at.server) return null;

        return (
            <div className="share-bar-bastian-feed">
                <div className="share-bar-bastian-feed-social"
                     ref="innerDiv"
                     data-theme="minimal"
                     data-title={this.props.title}
                     data-url={this.props.url}
                     data-image-url={this.props.imageUrl}></div>
            </div>
        );
    }
});

module.exports = Share;
